import { rgba } from 'polished';
import { blenderForeground } from '@clds/blender';
import { combineValues, globalTheme } from '@clds/component-theme';
export const borderColorMixin = ({ theme, variant, tone, isSelected, }) => isSelected
    ? tone === 'subtle'
        ? blenderForeground({ mode: 'surfaceSolid', variant, theme })
        : combineValues(globalTheme.palette.contrastHigh, (value) => rgba(value, 0.7))({ theme })
    : 'transparent';
//# sourceMappingURL=borderColorMixin.js.map